module.exports = __webpack_public_path__ + "static/img/2.f620ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R22/2.jpg
// module id = Hl9r
// module chunks = 1